export default {
  ADS_SCRIPT: '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
}